import type { ReactNode } from 'react';
import { useTier } from '../hooks/useTier.js';
import { FEATURE_REQUIREMENTS, type Tier } from '@vcard/shared';
import { UpgradePrompt } from './UpgradePrompt.js';

interface RequiresTierProps {
  feature: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function RequiresTier({ feature, children, fallback }: RequiresTierProps) {
  const { hasFeature, loading } = useTier();

  if (loading) return null;
  if (hasFeature(feature)) return <>{children}</>;

  const requiredTier = FEATURE_REQUIREMENTS[feature] as Tier | undefined;

  return (
    <>
      {fallback ?? (
        <UpgradeNudge feature={feature} {...(requiredTier !== undefined ? { requiredTier } : {})} />
      )}
    </>
  );
}

function UpgradeNudge({ requiredTier }: { feature: string; requiredTier?: Tier }) {
  return <UpgradePrompt requiredTier={requiredTier} />;
}
